/* tslint:disable */
/* eslint-disable */
/**
 * Tractable Identity Broker API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginExternalResponse
 */
export interface LoginExternalResponse {
    /**
     * Cognito URI that should be navigated to
     * @type {string}
     * @memberof LoginExternalResponse
     */
    url: string;
}


/**
 * Check if a given object implements the LoginExternalResponse interface.
 */
export function instanceOfLoginExternalResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function LoginExternalResponseFromJSON(json: any): LoginExternalResponse {
    return LoginExternalResponseFromJSONTyped(json, false);
}

export function LoginExternalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginExternalResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function LoginExternalResponseToJSON(value?: LoginExternalResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

